<template>
    <div>
        <div>
            <label
                class="mb-1 block text-sm font-medium"
                for="name"
                >{{ $t('file') }} <span class="text-danger-500">*</span></label
            >
        </div>
        <FileUploadButton
            title="acceptance_document"
            accept=".pdf"
            :file-name="modelValue.name"
            :url="modelValue.url"
            @submit="onFileSubmit"
            @delete="onFileDelete"
        />
    </div>
    <div>
        <SelectField
            v-model="modelValue.language"
            name="language"
            label="language"
            :options="Object.values(languages)"
            :required="true"
        />
    </div>
</template>
<script setup lang="ts">
import { SelectField } from '@src/components'
import { PlatformAcceptanceDocument } from '@src/types'
import { UploadFileResponse } from '@src/utils/api/s3'
import { useLanguageStore } from '@src/utils/stores/languages'
import { storeToRefs } from 'pinia'
import { Ref, toRefs } from 'vue'
import FileUploadButton from '../actions/FileUploadButton.vue'

const props = defineProps<{
    modelValue: Ref<PlatformAcceptanceDocument>
}>()

const { modelValue } = toRefs(props)
const emit = defineEmits(['update:modelValue'])

const languageStore = useLanguageStore()
const { languages } = storeToRefs(languageStore)

const onFileSubmit = (response: UploadFileResponse, fileName: string) => {
    modelValue.value.url = response.temp_storage_url
    modelValue.value.name = fileName
    modelValue.value.upload_key = response.key
}

const onFileDelete = () => {
    modelValue.value.url = null
    modelValue.value.name = null
    modelValue.value.upload_key = null
}
</script>
